export const COOKIE_AUTH_NAME = "userToken";
